export const KEYWORD_PENDING_LABEL = "Pending";

export function isKeywordMetricPending(value: unknown): boolean {
  if (value === -1 || value === "-1") return true;
  const n = Number(value);
  return Number.isFinite(n) && n === -1;
}

export function formatKeywordPendingNumber(
  value: number | string | null | undefined,
  options?: { empty?: string },
): string {
  const empty = options?.empty ?? "—";
  if (value === null || value === undefined) return empty;
  if (isKeywordMetricPending(value)) return KEYWORD_PENDING_LABEL;
  return String(Math.round(Number(value)));
}

export function formatKeywordPendingMoney(
  value: number | string | null | undefined,
  options?: { empty?: string },
): string {
  const empty = options?.empty ?? "—";
  if (value === null || value === undefined) return empty;
  if (isKeywordMetricPending(value)) return KEYWORD_PENDING_LABEL;
  return `$${Number(value).toFixed(2)}`;
}

/**
 * AUT-117: KW Sales specifically wants whole-dollar, comma-grouped amounts
 * ($1000.00 -> $1,000) -- deliberately a separate formatter from
 * formatKeywordPendingMoney rather than changing that one's rounding, since
 * formatKeywordPendingMoney is also used for PPC bid CSV exports elsewhere,
 * where cents are real (bids are often sub-dollar) and dropping them would
 * silently misreport a bid amount nobody asked to change.
 */
export function formatKeywordPendingSalesMoney(
  value: number | string | null | undefined,
  options?: { empty?: string },
): string {
  const empty = options?.empty ?? "—";
  if (value === null || value === undefined) return empty;
  if (isKeywordMetricPending(value)) return KEYWORD_PENDING_LABEL;
  return `$${Math.round(Number(value)).toLocaleString("en-US")}`;
}

export function formatKeywordPendingPercent(
  value: number | string | null | undefined,
  options?: { empty?: string },
): string {
  const empty = options?.empty ?? "—";
  if (value === null || value === undefined) return empty;
  if (isKeywordMetricPending(value)) return KEYWORD_PENDING_LABEL;
  return `${value}%`;
}

export function formatKeywordPendingRank(
  rank: number | null | undefined,
  options?: { notRanked?: string },
): string {
  const notRanked = options?.notRanked ?? "NA";
  if (rank === null || rank === undefined) return notRanked;
  if (isKeywordMetricPending(rank)) return KEYWORD_PENDING_LABEL;
  return String(rank);
}
